import script from "./WhatsAppTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppTemplates.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppTemplates.vue?vue&type=style&index=0&id=6d5a1c70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5a1c70"]])

export default __exports__